import React, { useEffect, useRef } from "react";

export const Reveal = ({ children, delay = 0 }) => {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.classList.add("is-visible");
                    obs.disconnect();
                }
            },
            { threshold: 0.08 },
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);
    return (
        <div ref={ref} className="reveal" style={{ transitionDelay: `${delay}ms` }}>
            {children}
        </div>
    );
};
